import * as _ from 'lodash';
import { PipeTransform, Pipe } from '@angular/core';

import { UserService } from 'services';

@Pipe({
    name: 'addAuthToken',
    standalone: false
})
export class AddAuthTokenPipe implements PipeTransform {
    constructor(public userService: UserService) {}

    transform(link: string): string {
        if (!link) return null;

        try {
            const url = new URL(link);
            url.searchParams.append('token', this.userService.getAuthToken());
            return url.toString();
        } catch (e) {
            return link;
        }
    }
}
